<template>
  <div class="StudentTutorsModal">

    <div class="m-modal" v-show="modal.condition" transition="expand">

      <div class="m-modal__inner">

        <h2 class="m-modal__inner__title" style="display: flex">
          <div style="width: 25%; cursor: pointer" @click="tab1">詳細</div>
          <div style="width: 25%; cursor: pointer" @click="tab2">JimCard</div>
          <div class="delete"><i class="fa fa-fw fa-trash-o" @click="deleteST"></i></div>
        </h2>

        <div class="m-modal__inner__content">

          <template v-if="tab.tab1">
            <table-c class="m-table" v-if="modal.list">
              <tr-c slot="tr-td">
                <th-c>状態</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.state" :options="modal.stateSelect" label="name" :show-labels="false" placeholder="状態"></multiselect>
                </td-c>
                <th-c>経過日数</th-c>
                <td-c v-bind:class="{ 'orange': elapsed7(modal.list.filing_date, modal.list.state), 'red': elapsed10(modal.list.filing_date, modal.list.state) }">{{modal.list.mapElapsed}}</td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>生徒</th-c>
                <td-c>{{modal.list.student.f_name}} {{modal.list.student.l_name}}</td-c>
                <template v-if="modal.list.tutor">
                  <th-c>先生</th-c>
                  <td-c>{{modal.list.tutor.f_name}} {{modal.list.tutor.l_name}}</td-c>
                </template>
                <template v-else>
                  <th-c>先生</th-c>
                  <td-c></td-c>
                </template>
              </tr-c>

              <tr-c slot="tr-td">
              </tr-c>

              <!-- <tr&#45;c slot="tr&#45;td"> -->
              <!--   <th&#45;c>指導開始日</th&#45;c> -->
              <!--   <td&#45;c><input type="text" v&#45;model="modal.list.guidance_period_start"></td&#45;c> -->
              <!--   <th&#45;c>指導終了日</th&#45;c> -->
              <!--   <td&#45;c><input type="text" v&#45;model="modal.list.guidance_period_end"></td&#45;c> -->
              <!-- </tr&#45;c> -->

              <tr-c slot="tr-td">
                <th-c>探し提出日</th-c>
                <td-c><input type="text" v-model="modal.list.filing_date"></td-c>
                <th-c>探し種類</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.matching_type" :options="modal.matching_typeSelect" label="name" :show-labels="false" placeholder="探し種類"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>決めた日</th-c>
                <td-c><input type="text" v-model="modal.list.matching_date"></td-c>
                <th-c>チェンジ理由</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.change_reason" :options="modal.change_reasonSelect" label="name" :show-labels="false" placeholder="チェンジ理由"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>探し月</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.matching_month" :options="modal.matching_monthSelect" label="name" :show-labels="false" placeholder="探し月"></multiselect>
                </td-c>
                <th-c>探し担当</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.charge_person" :options="filteredUsers" label="user" :show-labels="false" placeholder="探し担当"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>決めた人</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.decision_person" :options="filteredUsers" label="user" :show-labels="false" placeholder="決めた人"></multiselect>
                </td-c>
                <th-c>7日TEL</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.seven_days_tel" :options="modal.telSelect" label="name" :show-labels="false" placeholder="7日TEL"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>10日TEL</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.ten_days_tel" :options="modal.telSelect" label="name" :show-labels="false" placeholder="10日TEL"></multiselect>
                </td-c>
                <th-c>14日TEL</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.fourteen_days_tel" :options="modal.telSelect" label="name" :show-labels="false" placeholder="14日TEL"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>研修日</th-c>
                <td-c><input type="text" v-model="modal.list.training_date"></td-c>
                <th-c>研修check</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.training_check" :options="modal.zumiSelect" label="name" :show-labels="false" placeholder="研修check"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>資料</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.document" :options="modal.checkSelect" label="name" :show-labels="false" placeholder="資料"></multiselect>
                </td-c>
                <th-c>初回日期限</th-c>
                <td-c><input type="text" v-model="modal.list.first_day_limit"></td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>資料送付確認</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.document_sending_check" :options="modal.checkSelect" label="name" :show-labels="false" placeholder="資料送付確認"></multiselect>
                </td-c>
                <th-c>資料受取確認</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.document_receipt_check" :options="modal.checkSelect" label="name" :show-labels="false" placeholder="資料受取確認"></multiselect>
                </td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>初回日</th-c>
                <td-c><input type="text" v-model="modal.list.first_day"></td-c>
                <th-c>候補1<keep1-add :modal="modal"></keep1-add></th-c>
                <td-c>{{modal.list.keep_f_name1}} {{modal.list.keep_l_name1}}</td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>持ってる人</th-c>
                <td-c class="select">
                  <multiselect v-model="watch.hold_person" :options="filteredUsers" label="user" :show-labels="false" placeholder="持ってる人"></multiselect>
                </td-c>
                <th-c>候補2<keep2-add :modal="modal"></keep2-add></th-c>
                <td-c>{{modal.list.keep_f_name2}} {{modal.list.keep_l_name2}}</td-c>
              </tr-c>

              <tr-c slot="tr-td">
                <th-c>家庭TEL期限</th-c>
                <td-c><input type="text" v-model="modal.list.family_tel_limit"></td-c>
                <th-c>候補3<keep3-add :modal="modal"></keep3-add></th-c>
                <td-c>{{modal.list.keep_f_name3}} {{modal.list.keep_l_name3}}</td-c>
              </tr-c>

            </table-c>

            <table-c>
              <tr-c slot="tr-td">
                <td-c style="padding: 0"><textarea class="note1" v-model="modal.list.note" placeholder="備考"></textarea></td-c>
              </tr-c>
            </table-c>

          </template>

          <template v-if="tab.tab2">
            <div class="note2-box" style="position: absolute; padding: 0"><textarea class="note2" v-model="modal.list.note2" placeholder="備考2"></textarea></div>
          </template>

        </div>

        <div class="m-modal__inner__bottom">
          <btn @click.native="patchST">更新</btn>
          <btn @click.native="showModal">キャンセル</btn>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment'
import Keep1Add from '@/components/Pages/Student_tutors/Keep1Add'
import Keep2Add from '@/components/Pages/Student_tutors/Keep2Add'
import Keep3Add from '@/components/Pages/Student_tutors/Keep3Add'
export default {
  components: {
    'keep1-add': Keep1Add,
    'keep2-add': Keep2Add,
    'keep3-add': Keep3Add
  },
  props: {
    modal: Object
  },
  name: 'StudentTutorsModal',
  data () {
    return {
      tab: {
        tab1: true,
        tab2: false
      },

      student_tutor: {
        state: '',
        office_id: '',
        matching_type: '',
        change_reason: '',
        charge_person: 0,
        decision_person: 0,
        matching_month: '',
        seven_days_tel: '',
        ten_days_tel: '',
        fourteen_days_tel: '',
        training_check: '',
        document: '',
        document_sending_check: '',
        document_receipt_check: '',
        first_day_check: '',
        hold_person: 0
      },

      watch: {
        state: '',
        office_id: '',
        matching_type: '',
        change_reason: '',
        charge_person: '',
        decision_person: '',
        matching_month: '',
        seven_days_tel: '',
        ten_days_tel: '',
        fourteen_days_tel: '',
        training_check: '',
        document: '',
        document_sending_check: '',
        document_receipt_check: '',
        first_day_check: '',
        hold_person: ''
      }
    }
  },
  computed: {
    offices () {
      return this.$store.getters.offices
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    // filter
    filteredUsers () {
      let self = this
      if (self.user.office_id === 1) {
        return self.users.filter(user => {
          return user.office_id === 1 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 2) {
        return self.users.filter(user => {
          return user.office_id === 2 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 3) {
        return self.users.filter(user => {
          return user.office_id === 3 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 4) {
        return self.users.filter(user => {
          return user.office_id === 4 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 5) {
        return self.users.filter(user => {
          return user.office_id === 5 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 6) {
        return self.users.filter(user => {
          return user.office_id === 6 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 7) {
        return self.users.filter(user => {
          return user.office_id === 7 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 8) {
        return self.users.filter(user => {
          return user.office_id === 8 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 9) {
        return self.users.filter(user => {
          return user.office_id === 9 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 10) {
        return self.users.filter(user => {
          return user.office_id === 10 && user.hide_flag !== 1
        })
      } else {
        return self.users.filter(user => {
          return user.hide_flag !== 1
        })
      }
    }
  },
  watch: {
    'watch.state': function (now, old) {
      if (now) {
        this.student_tutor.state = now.value
      } else {
        this.student_tutor.state = ''
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.student_tutor.office_id = now.id
      } else {
        this.student_tutor.office_id = ''
      }
    },

    'watch.matching_type': function (now, old) {
      if (now) {
        this.student_tutor.matching_type = now.value
      } else {
        this.student_tutor.matching_type = ''
      }
    },

    'watch.change_reason': function (now, old) {
      if (now) {
        this.student_tutor.change_reason = now.value
      } else {
        this.student_tutor.change_reason = ''
      }
    },

    'watch.charge_person': function (now, old) {
      if (now) {
        this.student_tutor.charge_person = now.id
      } else {
        this.student_tutor.charge_person = 0
      }
    },

    'watch.decision_person': function (now, old) {
      if (now) {
        this.student_tutor.decision_person = now.id
      } else {
        this.student_tutor.decision_person = 0
      }
    },

    'watch.matching_month': function (now, old) {
      if (now) {
        this.student_tutor.matching_month = now.value
      } else {
        this.student_tutor.matching_month = ''
      }
    },

    'watch.seven_days_tel': function (now, old) {
      if (now) {
        this.student_tutor.seven_days_tel = now.value
      } else {
        this.student_tutor.seven_days_tel = ''
      }
    },

    'watch.ten_days_tel': function (now, old) {
      if (now) {
        this.student_tutor.ten_days_tel = now.value
      } else {
        this.student_tutor.ten_days_tel = ''
      }
    },

    'watch.fourteen_days_tel': function (now, old) {
      if (now) {
        this.student_tutor.fourteen_days_tel = now.value
      } else {
        this.student_tutor.fourteen_days_tel = ''
      }
    },

    'watch.training_check': function (now, old) {
      if (now) {
        this.student_tutor.training_check = now.value
      } else {
        this.student_tutor.training_check = ''
      }
    },

    'watch.document': function (now, old) {
      if (now) {
        this.student_tutor.document = now.value
      } else {
        this.student_tutor.document = ''
      }
    },

    'watch.document_sending_check': function (now, old) {
      if (now) {
        this.student_tutor.document_sending_check = now.value
      } else {
        this.student_tutor.document_sending_check = ''
      }
    },

    'watch.document_receipt_check': function (now, old) {
      if (now) {
        this.student_tutor.document_receipt_check = now.value
      } else {
        this.student_tutor.document_receipt_check = ''
      }
    },

    'watch.first_day_check': function (now, old) {
      if (now) {
        this.student_tutor.first_day_check = now.value
      } else {
        this.student_tutor.first_day_check = ''
      }
    },

    'watch.hold_person': function (now, old) {
      if (now) {
        this.student_tutor.hold_person = now.id
      } else {
        this.student_tutor.hold_person = 0
      }
    },

    'modal.condition': function (now, old) {
      if (now) {
        this.watch.state = this.modal.stateSelect.filter(state => {
          return state.value === this.modal.list.state
        })[0]

        this.watch.office_id = this.offices.filter(office => {
          return office.id === this.modal.list.office_id
        })[0]

        this.watch.matching_type = this.modal.matching_typeSelect.filter(matching_type => {
          return matching_type.value === this.modal.list.matching_type
        })[0]

        this.watch.change_reason = this.modal.change_reasonSelect.filter(change_reason => {
          return change_reason.value === this.modal.list.change_reason
        })[0]

        this.watch.charge_person = this.users.filter(user => {
          return user.id === this.modal.list.charge_person
        })[0]

        this.watch.decision_person = this.users.filter(user => {
          return user.id === this.modal.list.decision_person
        })[0]

        this.watch.matching_month = this.modal.matching_monthSelect.filter(matching_month => {
          return matching_month.value === this.modal.list.matching_month
        })[0]

        this.watch.seven_days_tel = this.modal.telSelect.filter(tel => {
          return tel.value === this.modal.list.seven_days_tel
        })[0]

        this.watch.ten_days_tel = this.modal.telSelect.filter(tel => {
          return tel.value === this.modal.list.ten_days_tel
        })[0]

        this.watch.fourteen_days_tel = this.modal.telSelect.filter(tel => {
          return tel.value === this.modal.list.fourteen_days_tel
        })[0]

        this.watch.training_check = this.modal.zumiSelect.filter(check => {
          return check.value === this.modal.list.training_check
        })[0]

        this.watch.document = this.modal.checkSelect.filter(check => {
          return check.value === this.modal.list.document
        })[0]

        this.watch.document_sending_check = this.modal.checkSelect.filter(check => {
          return check.value === this.modal.list.document_sending_check
        })[0]

        this.watch.document_receipt_check = this.modal.checkSelect.filter(check => {
          return check.value === this.modal.list.document_receipt_check
        })[0]

        this.watch.first_day_check = this.modal.checkSelect.filter(check => {
          return check.value === this.modal.list.first_day_check
        })[0]

        this.watch.hold_person = this.users.filter(user => {
          return user.id === this.modal.list.hold_person
        })[0]
      }
    }
  },
  methods: {
    elapsed7 (filing_date, state) {
      if (moment(filing_date).add(7, 'days') < new Date() && moment(filing_date).add(10, 'days') > new Date() && state !== 5) {
        return true
      }
    },

    elapsed10 (filing_date, state) {
      if (moment(filing_date).add(10, 'days') < new Date() && state !== 5) {
        return true
      }
    },

    tab1 () {
      this.tab.tab1 = true
      this.tab.tab2 = false
    },

    tab2 () {
      this.tab.tab1 = false
      this.tab.tab2 = true
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(selectedOption.name)
      // console.log(selectedOption.value)
    },

    showModal () {
      this.modal.condition = !this.modal.condition
    },

    patchST () {
      setTimeout(() => {
        this.$store.dispatch('patchST', {
          student_tutor: this.student_tutor,
          modal: this.modal
        })
      }, 0)
    },

    deleteST () {
      this.$store.dispatch('deleteST', {
        modal: this.modal
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.delete {
  width: 50%;
  color: #fff;
  text-align: right;
}

.table {
  margin-top: 0;
  box-shadow: none;
}
.th, .td {
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.note1 {
  width: 100%;
  border: none;
  outline: 0;
  height: 50px;
}
.note2-box {
  border: solid 1px #ccc;
  position: absolute;
  width: calc(100% - 13px);
  height: calc(100% - 3px);
}
.note2 {
  width: 100%;
  height: 100%;
  border: none;
  outline: 0;
}

.m-modal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  top: 0;
  left: 0;
  z-index: 1003;
  &__inner {
    display: flex;
    flex-direction: column;
    min-width: 80%;
    min-height: 503px;
    max-height: 80%;
    /* overflow: scroll; */
    background-color: #fff;
    box-shadow: 0 0 10px #ccc;
    &__title {
      margin: 0.5rem;
      padding: 0.5rem;
      background: #37474F;
      color: #fff;
    }
    &__content {
      overflow: auto;
      padding: 0 .5rem 0 .5rem;
      flex: 1;
      position: relative;
    }
    &__bottom {
      padding: .5rem;
      align-self: flex-end;
      width: 100%;
      display: flex;
      .m-btn {
        margin-top: 0;
      }
    }
  }
}

.orange {
  background: #FF9100;
  color: #fff;
}

.red {
  background: #FF1744;
  color: #fff;
}

</style>

<style lang="scss">
.StudentTutorsModal {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// Student_tutorsModal.vue?ce5c1796